import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/crew.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { CrewService } from '../services/crew.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setVehicleOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const crewService = new CrewService(serviceId)
  try {
    const response: IOptionsResponse = yield call([crewService, crewService.getVehicleOptions])
    const { entity } = response
    yield put(actions.setVehicleOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setVehicleOptions() error: ${e}`))
  }
}
export function* setVehicleOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setVehicleOptions)
}
